export default {"src":"/_next/static/media/EHA-Booking-Logo.34a9e272.svg","height":155,"width":146};